/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-09 19:44:42
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import { Integer, IViewDate } from 'src/types/base';
import { Constructor } from 'vue-tsx-support';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil, GetMillisecondType } from 'src/util/dateTimeUtil';
import { CommonUtil } from 'src/util/commonUtil';

export namespace OperateModalVOI {
    export interface InputItemsI {
        component: Constructor<any>;
        props: any;
        labelWidth?: number;
        field: string;
        label: string;
        realField?: string[];
        dataType?: string
        required?: boolean
        timeType?: string
        dealParam?(data): object;
    }
    export interface PropsI {
        dataSource?: DataSourceI;

        saveSuccess?(params?: any): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        name: string;
    }
    export interface DataSourceI {
        title: string
        inputItems: InputItemsI[]
        defaultParams?: any
        api(params: any): Promise<any>
    }
}

@Component
class OperateModal extends Vue.Component<OperateModalVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Object,
    })
    dataSource!: OperateModalVOI.DataSourceI;


    @Prop({
        type: Function,
    })
    saveSuccess!: (params?: any) => any;

    visible: boolean = false;

    loading: boolean = false;

    formData: OperateModalVOI.FormDataI = {
        name: '',
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if((this.dataSource as any).inputItems.length>0) {
            if (!(await this.$validate('formValidate'))) {
                return;
            }
        }
        if(this.dataSource.api) {
            this.loading = true;
            let {code} = await this.dataSource.api({
                ...(this.dataSource.defaultParams||{}),
                ...this.getQueryObj(),
            })
            this.loading = false;
            if (code === 0) {
                Toast.success('操作成功！');
                this.saveSuccess();
                this.closeModal();
            }
        } else {
            this.saveSuccess(this.getQueryObj());
            this.closeModal();
        }
       
    }
    getNode(h, i: OperateModalVOI.InputItemsI) {
        let { value, ...props } = i.props;
        return h(i.component, {
            props: { value: i.props.value, ...props },
            on: { input: v => (i.props.value = v) },
        });
    }
    getQueryObj<T>(): T {
        let inputItems:OperateModalVOI.InputItemsI[]= this.dataSource.inputItems as any
        let o: any = {};
        for (let i = 0, l = inputItems.length; i < l; i++) {
            let item = inputItems[i];
            if(item.dealParam) {
                o = {...o,...item.dealParam(item.props.value)}
                continue
            }
            switch (item.component) {
                case DatePicker:
                    let timeType = item.timeType;
                    if ((item.props.type || 'daterange').indexOf('range') > -1) {
                        let startType!: GetMillisecondType, endType!: GetMillisecondType;
                        if (item.props.type === 'daterange') {
                            startType = 'start';
                            endType = 'end';
                        } else if (item.props.type === 'monthrange') {
                            startType = 'monthStart';
                            endType = 'monthEnd';
                        }
                        if ((item.props.value as IViewDate[])[0]) {
                            let field = item.realField ? item.realField[0] : item.field + 'Start';
                            o[field] = DateTimeUtil.getSecondFromIviewDate((item.props.value as IViewDate[])[0], startType);
                            if (timeType !== 'number') {
                                o[field] =DateTimeUtil.formateDate(o[field]?o[field]*1000:null, timeType);
                            }
                        }
                        if ((item.props.value as IViewDate[])[1]) {
                            let field = item.realField ? item.realField[1] : item.field + 'End';
                            o[field] = DateTimeUtil.getSecondFromIviewDate((item.props.value as IViewDate[])[1], endType);

                            if (timeType !== 'number') {
                                o[field] = DateTimeUtil.formateDate(o[field]?o[field]*1000:null, timeType);
                            }
                        }
                    } else {
                        o[item.field] =
                            timeType === 'number'
                                ? DateTimeUtil.getSecondFromIviewDate(item.props.value as IViewDate)
                                : DateTimeUtil.formateDate(item.props.value as IViewDate, timeType);
                    }
                    break;
                    break;
                default:
                    o[item.field] = item.props.value;
                    break;
            }
        }
        return o;
    }
    getRules(i: OperateModalVOI.InputItemsI) {
        let rules:any = [
        ]
        if(i.required) {
            rules.push({required: true, message: i.label+ '必填', trigger: 'blur,change', type: i.dataType||'string'})
            if(i.component === DatePicker && ~i.props.type.indexOf('range')) {
                rules.push({validator:(rule, value, callback) => {
                    if(value.length ===0 || value.some(i=> CommonUtil.isFieldEmpty(i))) {
                        callback(new Error(i.label+ '必填'))
                    }else {
                        callback()
                    }
                }, trigger: 'blur,change'})
            }
        }
        return rules
    }
    render(h) {
        return (
            <Modal title={this.dataSource.title} width="500" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form  ref="formValidate" labelWidth={100} model={this.dataSource}  style="width:80%">
                    {(this.dataSource as any).inputItems.map((i,index) => {
                        return (
                            <form-item
                                labelWidth={i.labelWidth}
                                label={i.label}
                                prop={'inputItems.'+index+'.props.value'}
                                rules={
                                    this.getRules(i)
                                }
                            >
                                {this.getNode(h, i)}
                            </form-item>
                        );
                    })}
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertOperateModal(dataSource: OperateModalVOI.DataSourceI): Promise<any> {
    return new Promise((resolve, reject) => {
        modalFactory<OperateModalVOI.PropsI>(OperateModal)({
            dataSource,
            saveSuccess(params) {
                resolve(params||true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
